import React, { useRef, useEffect, useState } from 'react';
//{...(checkCondition ? { transform: "rotate(180 800 450)" } : {})}
//transform: `scale(-1,1) translate(${-width},0) rotate(180 ${width/2} ${height})`}
//{...(checkCondition ? {transform: `scale(-1,1) translate(${-width},${-height}) rotate(180 ${width/2} ${height})`} : {})}
//width>=height ? -width/4 : -height : width>=height ? width/4 : height

function useParentSize(ref, options = {}) {
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const observeTarget = ref.current;
        if (!observeTarget) return;

        const resizeObserver = new ResizeObserver((entries) => {
            if (!Array.isArray(entries) || !entries.length) return;
            const { width, height } = entries[0].contentRect;
            setSize({ width, height });
        });

        resizeObserver.observe(observeTarget, options);

        return () => {
            resizeObserver.unobserve(observeTarget);
        };
    }, [ref, options]);

    return size;
}

const AnimatedBackground = ({checkCondition = false, parentRef}) => {
    const [viewBox, setViewBox] = useState("0 0 1600 900");

    const { width, height } = useParentSize(parentRef);

    useEffect(() => {
        const newViewBox = `0 0 ${width} ${height}`;
        setViewBox(newViewBox);
    }, [width, height]);

    return (
        <svg style={{
            backgroundColor: '#0e4166',
            position: 'relative',
        }} version="1.1"
             width={width} height={height} viewBox={`0 ${checkCondition ? -(0.05*width+160): 0.05*width+160} 1600 900`}

             preserveAspectRatio={checkCondition ? "xMidYMid slice" : "xMidYMid slice"}>
            <defs>
                <linearGradient id="bg">
                    <stop offset="0%"
                          style={checkCondition ? {stopColor: "rgba(115, 209, 72, 0.2)"} : {stopColor: "rgba(130, 158, 249, 0.06)"}}></stop>
                    <stop offset="50%" style={{stopColor: "rgba(76, 190, 255, 0.6)"}}></stop>
                    <stop offset="100%"
                          style={checkCondition ? {stopColor: "rgba(130, 158, 249, 0.06)"} : {stopColor: "rgba(115, 209, 72, 0.2)"}}></stop>
                </linearGradient>
                <path id="wave" fill="url(#bg)" d="M-363.852,502.589c0,0,236.988-41.997,505.475,0
    s371.981,38.998,575.971,0s293.985-39.278,505.474,5.859s493.475,48.368,716.963-4.995v560.106H-363.852V502.589z"/>
            </defs>
            <g {...(checkCondition ? {transform: `scale(-1,1) translate(-1600,-900) rotate(180 800 900)`} : {})}>
                <use xlinkHref='#wave' opacity=".3">
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="translate"
                        dur="10s"
                        calcMode="spline"
                        values="270 230; -334 180; 270 230"
                        keyTimes="0; .5; 1"
                        keySplines="0.42, 0, 0.58, 1.0;0.42, 0, 0.58, 1.0"
                        repeatCount="indefinite"/>
                </use>



                <use xlinkHref='#wave' opacity=".6">
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="translate"
                        dur="8s"
                        calcMode="spline"
                        values="-270 230;243 220;-270 230"
                        keyTimes="0; .6; 1"
                        keySplines="0.42, 0, 0.58, 1.0;0.42, 0, 0.58, 1.0"
                        repeatCount="indefinite"/>
                </use>
                <use xlinkHref='#wave' opacity=".9">
                    <animateTransform
                        attributeName="transform"
                        attributeType="XML"
                        type="translate"
                        dur="6s"
                        calcMode="spline"
                        values="0 230;-140 200;0 230"
                        keyTimes="0; .4; 1"
                        keySplines="0.42, 0, 0.58, 1.0;0.42, 0, 0.58, 1.0"
                        repeatCount="indefinite"/>
                </use>
            </g>
        </svg>
    );
}

export default AnimatedBackground;
